import { Skeleton } from '@common/components';

export function SearchMarketCardSkeleton() {
  return (
    <div
      role="status"
      aria-label="웰마켙 상품 로딩 중"
      className="flex flex-col gap-8"
    >
      <Skeleton className="aspect-square w-full rounded-xlarge" />
      <div className="flex flex-col gap-8">
        <Skeleton className="h-20 w-100 rounded-xxsmall" />
        <div className="flex flex-col gap-4">
          <Skeleton className="h-20 w-full rounded-xxsmall" />
          <Skeleton className="h-20 w-3/4 rounded-xxsmall" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-16 w-80 rounded-xxsmall" />
          <Skeleton className="h-24 w-3/4 rounded-xxsmall" />
        </div>
        <Skeleton className="h-20 w-80 rounded-xxsmall" />
      </div>
    </div>
  );
}

interface SearchMarketCardSkeletonListProps {
  count: number;
}

export function SearchMarketCardSkeletonList({
  count,
}: SearchMarketCardSkeletonListProps) {
  return (
    <ul
      aria-busy="true"
      className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:grid-cols-2 mobile-tablet:px-20"
    >
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <SearchMarketCardSkeleton />
        </li>
      ))}
    </ul>
  );
}
